export const MINIO_BUCKET_NAME = "pressurize";